module.exports = __webpack_public_path__ + "static/media/dogs.d392fdb6.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/dogs.jpg
 ** module id = 453
 ** module chunks = 0
 **/